<template>
    <section class="footer">
            <div class="spacer layer1"></div>
        <div class="content-wrapper">
            <div class="copyright">
                <p class="made-with">Made with <img src="https://i.imgur.com/Yg7MzAm.png" alt=""></p>
                <p>	&copy 2023 Olivier Śmiałkowski</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Contact",
}
</script>

<style lang="scss" scoped>
.spacer {
    aspect-ratio: 1060/110;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.layer1 {
    background-image: url('@/assets/wave4.svg');
}

.content-wrapper {
    padding: 0.2rem 0.5rem 2.7rem; 
    background-color: #22262c;
    display: flex;
    justify-content: center;
     @media (max-width: 1024px) {
            padding: 0.5rem 0.5rem 1.8rem;
    }
        @media (max-width:768px) {
                padding: 0.75rem 0.5rem 1.5rem
        }
    @media (max-width:425px) {
            padding: 0.5rem 0 1rem 0;
            align-items: center;
    }
    @media (max-width:395px) {
            padding: 0.5rem 0 0.85rem 0;
    }
    .copyright {
        color: #fff;
        display: flex;
        align-items: center;
        font-size: 1.15rem;
        @media(min-width:2250px) {
            font-size: 1.3rem;
        }
         @media (max-width:768px) {
                font-size: 1.1rem;
        }
         @media (max-width:425px) {
                font-size: 0.95rem;
        }
        p {
            margin: 0 1rem 0;
        }
        .made-with {
            display: flex;
            align-items: center;
            img {
                margin-bottom: 0.3rem;
                margin-left: 0.3rem;
                width: 26px;
                @media(max-width:425px) {
                    width: 22px;
                }
            }
        }
    }
    }

</style>